/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-key */
import React from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { Button, Col, List, Row } from 'antd-v5';
import { SettingsContent } from '../../../components/SettingsContent';
import { INQUIRY_MESSAGES, getInquiryAutoMessages } from '../../../../../../api/rolexAutoMessages';
import { convertMessageTemplate } from '../../../../../../utils/convertMessageTemplate';

const formatTiming = (scale, interval) => {
  if (scale === undefined || scale === null) return '—';
  if (scale === 0) return 'Immediately';
  if (interval === 'HOUR') return `${scale} hour${scale > 1 ? 's' : ''} after`;
  if (interval === 'MONTH') return `Every ${scale} month${scale > 1 ? 's' : ''}`;
  const unit = interval.charAt(0) + interval.slice(1).toLowerCase();
  return `${scale} ${unit}${scale > 1 ? 's' : ''}`;
};

export const InquiryMessages = () => {
  const { data: config, isFetching } = useQuery(
    'inquiryAutoMessages',
    async () => {
      try {
        const response = await getInquiryAutoMessages();
        return INQUIRY_MESSAGES.map(msg => {
          const existing = response[msg.id] || {};
          return {
            ...msg,
            message: existing.msg || msg.defaultMessage || '',
            enabled: existing.active === 1,
            actionScale: existing.action_scale,
            actionInterval: existing.action_interval,
          };
        });
      } catch (e) {
        console.error('Error fetching inquiry auto messages:', e);
        return [];
      }
    },
    {
      refetchOnWindowFocus: false,
      initialData: [],
    },
  );

  return (
    <SettingsContent title="Messages">
      <List
        header={<InquiryConfigHeader />}
        className="w-100-P m-btm-16"
        size="small"
        dataSource={config}
        renderItem={item => <InquiryConfigItem item={item} />}
        loading={isFetching}
      />
    </SettingsContent>
  );
};

const InquiryConfigHeader = () => {
  return (
    <Row justify="space-between" align="middle" style={{ width: '100%' }}>
      <Col span={4}>
        <HeaderItem name="Name" />
      </Col>
      <Col span={3}>
        <HeaderItem name="Timing" />
      </Col>
      <Col span={9}>
        <HeaderItem name="Message" />
      </Col>
      <Col span={2}>
        <HeaderItem name="Status" />
      </Col>
      <Col span={2} />
    </Row>
  );
};

const HeaderItem = ({ name }) => {
  return (
    <div className="flex-row p-left-6" style={{ color: '#0000006B' }}>
      {name}
    </div>
  );
};

const ContentItem = ({ content }) => {
  return <div className="flex-row ">{content}</div>;
};

const InquiryConfigItem = ({ item }) => {
  const { push } = useHistory();
  return (
    <List.Item
      style={{ margin: 0 }}
      styles={{ actions: { margin: 0 } }}
      key={item.id}
      data-testid="inquiries__config--message-row"
    >
      <Row justify="space-between" align="middle" style={{ width: '100%' }}>
        <Col span={4}>
          <ContentItem content={item.name} />
        </Col>
        <Col span={3}>
          <ContentItem content={formatTiming(item.actionScale, item.actionInterval)} />
        </Col>
        <Col span={9}>
          <ContentItem
            content={
              <div
                style={{ textAlign: 'left' }}
                dangerouslySetInnerHTML={{ __html: convertMessageTemplate(item.message) }}
              />
            }
          />
        </Col>
        <Col span={2}>
          <ContentItem
            content={
              <span style={{ color: item.enabled ? '#7fbd31' : undefined }}>
                {item.enabled ? 'Enabled' : 'Disabled'}
              </span>
            }
          />
        </Col>
        <Col span={2}>
          <div className="flex-row items-end w-100-P justify-end">
            <Button
              onClick={() => push(`/Configuration/rolex/messages/${item.id}`)}
              variant="text"
              color="primary"
              htmlType="button"
              className="m-right-8"
            >
              Edit
            </Button>
          </div>
        </Col>
      </Row>
    </List.Item>
  );
};
